import { render, staticRenderFns } from "./DetailViewIcon.vue?vue&type=template&id=5dea0f5e&scoped=true"
import script from "./DetailViewIcon.vue?vue&type=script&lang=js"
export * from "./DetailViewIcon.vue?vue&type=script&lang=js"
import style0 from "./DetailViewIcon.vue?vue&type=style&index=0&id=5dea0f5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dea0f5e",
  null
  
)

export default component.exports